import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { LessorList } from "../models/lessor";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
  providedIn: "root",
})
export class LessorService {
  private readonly lessorUrl = "lessors";
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.lessorUrl;
  }

  public getLessors(productCode: string): Observable<LessorList> {
    const params = new HttpParams().set("productCode", productCode);
    return this.http.get<LessorList>(this.baseUrl, { params });
  }
}
